import React from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";

/**
 * Initialize Sentry React Router v6 integration
 * This should be called once in your app initialization
 */
export const initSentryReactRouter = () => {
  // Update Sentry to use React Router v6 browser tracing integration
  Sentry.addIntegration(
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    })
  );
};

/**
 * Wrapped createBrowserRouter with Sentry instrumentation
 * Use this instead of the regular createBrowserRouter
 */
export const createSentryBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
